import type {GlobalStateContext} from "piral-core";

import {BFFOAuthClient} from "@prowin/bff-oauth-client";
import {Logger} from "@prowin/logger";

export function createActions(oauth: BFFOAuthClient) {

    return {
        doUserLogout(ctx: GlobalStateContext): void {
            try {
                oauth.logout();
                setTimeout(()=> {
                    ctx.emit('user-logout',{});
                }, 0);
            } catch (error) {
                Logger.error("Error in doUserLogout");
            }
        },

        refreshToken: (): Promise<object> => {
            return Promise.resolve({refreshToken: "", accessToken: "", data: {"expires_at": ""}, bearer: ""})
        }
    };
}
